<template>
  <TransactionTemplate
    :screenJson="getScreenJson"
    :setLoading="setLoading"
    :localDataGrid="true"
    :gcPopupBankFeeConfig="gcPopupBankFeeConfig"
    :backButtonRoute="backButtonRoute"
    ref="customer-receipt"
    :data-model="dataModel"
    :backRouteAppend="undefined"
    :isLoaded="loaded"
    v-if="!reload"
    :validationSummary="validationSummary"
    :serverError="serverError"
    :paging="false"
  />

  <!-- :dxScrolling="'standard'" -->
</template>

<script>
import TransactionTemplate from "../../templates/transaction";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import CheckBox from "devextreme/ui/check_box";
import { mapGetters } from "vuex";
import { CustomerReceiptService } from "../../_services/api/customers/customer-receipt-service";
import { CustomerService } from "../../_services/api/customers/customer.service";
// import { FactorService } from "../../_services/api/sales/factor.service";
import { CompanyCurrencyService } from "../../_services/api/accounts/company-currency.service";
import { DefaultCompanyBranchDivisionService } from "../../_services/api/sales/default-company-branch-dicision.service";
import { CustomerInvoiceService } from "../../_services/api/customers/customer-invoice.service";
import { getFactorByCode } from "../../_store/helpers";
import { ForeignCurrencyService } from "../../_services/api/settings/accounting/foreign-currency.service";
import { CompanyService } from "../../_services/api/accounts/company.service";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import { FxToBaseCurrency } from "../../_helpers/formulas/sales-formulas";
import { BankFeeSettings } from "../../_services/api/finance/bank-fee-settings.service";
import ArrayStore from "devextreme/data/array_store";
import { FeatureStorage } from "../../_services/storage";
import retryAsync from "../../_helpers/network/network";

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      IsSettlementDateEnforced: undefined,
      loaded: false,
      setLoading: false,
      InvoiceNumber: undefined,
      dataModel: {
        Code: undefined,
        Allocated: undefined,
        Balance: undefined,
        AccountingPeriod: undefined,
        // Date: Date.now(),
        DueDate: undefined,
        Reference: undefined,
        PaymentMethods: undefined,
        PaymentMethod: undefined,
        BankAccountCode: undefined,
        BankAccount: undefined,
        DateDeposited: undefined,
        Customer: undefined,
        Payer: undefined,
        Currency: undefined,
        ExchangeRate: 1.0,
        footerBalance: undefined,
        footerAllocated: undefined,
        Amount: 0.0,
        Rounding: 0.0,
        CustomerCode: undefined,
        AccountingPeriodCode: undefined,
        BillToCustomer: undefined,
        BranchCode: undefined,
        CompanyCode: undefined,
        DivisionCode: undefined,
        FXIncTaxAmount: 0.0,
        FXVarianceRounding: 0.0,
        FXDiscAmount: undefined,
        FXAmount: 0.0,
        AdjustmentAmount: 0.0,
        AdjustmentBranchCode: undefined,
        AdjustmentDivisionCode: undefined,
        AdjustmentComment: undefined,
        AdjustmentGLAccountCode: 0,
        FXRounding: 0.0,
        BaseAdjustmentAmount: 0.0,
        FXUnallocatedAmount: 0.0,
        UnallocatedAmount: 0.0,
        DateIn: new Date(),
        DateChanged: "",
        DateCreated: "",
        ChangedBy: "",
        CreatedBy: "",
      },
      reload: false,
      validationSummary: [],
      serverError: {},
      status: undefined,
      PaymentMaxDate: undefined,
      PaymentMinDate: new Date(),
      BaseCurrency: "AUD",
      defaultDataModel: {
        DefaultBranchCode: null,
        DefaultDivisionCode: null,
        DefaultBranchDescription: null,
        DefaultDivisionDescription: null,
      },
      bankFeePopupVisible: false,
      localDataSource: new ArrayStore({
        key: "ID",
        data: [],
      }),
      SelectedOnHeader: false,
      suppressHeaderFocus: false,
    };
  },

  async created() {
    this.$store.dispatch("dataContext/setReviewDataSource", []);
  },
  async mounted() {
    this.$store.dispatch("dataContext/setReviewDataSource", []);
    this.initialized();
  },
  beforeDestroy() {},

  computed: {
    IsForeignCurrencyAccount() {
      return this.dataModel.Currency !== this.BaseCurrency;
    },
    gcPopupBankFeeConfig() {
      return {
        visible: this.bankFeePopupVisible,
        callback: this.bankFeeCallback,
        bankFeeSettings: {
          GLAccount: this.dataModel.AdjustmentGLAccountCode,
          Branch: this.dataModel.AdjustmentBranchCode,
          Division: this.dataModel.AdjustmentDivisionCode,
          Comment: this.dataModel.AdjustmentComment,
        },
      };
    },
    getGridFilter() {
      return this.isNavigatedFromCustomerPage()
        ? [
            `CustomerBillToCode eq '${this.dataModel.BillToCustomer}' ${
              this.dataModel.DueDate
                ? `and (CalculatedDueDate le ${new Date(
                    this.dataModel.DueDate,
                  ).toFilterDateString()} or CalculatedDueDate eq null)`
                : ""
            }`,
          ]
        : [
            `CustomerBillToCode eq '${this.dataModel.BillToCustomer}' ${
              this.dataModel.DueDate
                ? `and (CalculatedDueDate le ${new Date(
                    this.dataModel.DueDate,
                  ).toFilterDateString()} or CalculatedDueDate eq null)`
                : ""
            } and RefNo eq '${
              this.baseView.query.invoiceNumber
            }' and DateInDate le ${this.dataModel.DateIn.toSaveDateEndTime()}Z`,
          ];
    },
    ...mapGetters({ reviewDataSource: "dataContext/getReviewDataSource" }),
    backButtonRoute() {
      const { from: parentPage } = this.baseView.query;
      if (parentPage == "customer-list") {
        return "/customer";
      } else if (parentPage == "customer-detail") {
        if (this.baseView.mode == "create")
          return "/customer/review/" + this.baseView.id;
        else return "/customer/review/" + this.dataModel.CustomerCode;
      } else if (parentPage == "invoice-order-list") {
        return "/invoiced-order";
      } else {
        return "/invoiced-order";
      }
    },

    getScreenJson() {
      var screenJson = {
        title: "Customer Receipt",
        endpoint: this.isReviewMode()
          ? {
              primary: "CashReceipt",
              expand: "Customer($select=Name)",
              postProcess: this.cashReceiptPostProcess,
            }
          : { primary: undefined },
        headerData: {
          headerToolbar: {
            save: this.baseView.mode == "create",
            saveCallback: this.saveCustomerReceipt,
            customButtons: [
              {
                label: "save",
                icon: "..",
                type: " ",
                click: "",
                menu: [
                  {
                    label: "Credit Comments",
                    clickAction: "",
                  },
                ],
              },
            ],

            toolbarFormItems: [
              {
                screenField: "BillToCustomer",
                dataField: "BillToCustomer",
                cssClass: "toolbar-customer-label",
                visible: this.baseView.mode != "review",
                editorOptions: {
                  tabIndex: 1,
                  dropDownOptions: {
                    minWidth: 300,
                  },
                  width: 300,
                  placeholder: "Customer Name",
                  // onValueChanged: this.onCustomerCodeValueChanged.bind(this),
                  showClearButton: true,
                  onValueChanged: (e) => {
                    var items = e.component.getDataSource().items();
                    var item = items.filter((x) => x.Code == e.value);

                    this.onCustomerCodeItemClicked({
                      itemData: item[0],
                    });
                  },
                  // select: [
                  //   "Code",
                  //   "Name",
                  //   "CurrencyCode",
                  //   "BillToCustomerCode",
                  // ],
                },
                label: {
                  text: "Customer",
                  visible: false,
                },
                required: true,
                displayExpr: (item) => {
                  if (item) return item.Code + " - " + item.Name;
                  else return "";
                },
                searchExpr: ["Code", "Name"],
                itemTemplate: (data) => {
                  return ` <div class="custom-auto-complete" id="${data.Code}" >
                        <span class="auto-complete-primary">
                          ${data.Name}
                        </span>
                        <span class="record-secondary gc-grid-code">
                           ${data.Code}
                        </span> 
                      </div>`;
                },
              },
            ],
            screenName: "Customer Receipt Review",
            pdf: this.isReviewMode(),
            email: this.baseView.mode == "review",
            audit: true,
            status: this.isReviewMode(),
            notes: false,
            emailMenuItems: {
              referenceNoField: "Code",

              makeDisabled: (dataModel, emailRecords) => {
                var items = [];
                emailRecords.forEach((element) => {
                  items.push({
                    ReportDisplayName: element.ReportDisplayName,
                    ScreenName: element.ScreenName,
                    ScreenLayoutApplicationFeatureCode:
                      element.ScreenLayoutApplicationFeatureCode,
                    TransactionCode: element.TransactionCode,
                    disabled: element.disabled,
                  });
                });
                return items;
              },
            },
            formContentReady: (e) => {
              if (e && this.baseView.mode != "review" && this.loaded)
                this.onHeaderFormContentReady(e);
            },

            auditItems: [
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    dataField: "FormattedDateCreated",
                    label: { text: "Created By", location: "left" },
                    editorType: "dxTextBox",
                    editorOptions: {},
                  },
                  {
                    dataField: "FormattedDateChanged",
                    label: { text: "Changed By", location: "left" },
                    editorType: "dxTextBox",
                    editorOptions: {},
                  },
                ],
              },
            ],
            ellipsis:
              this.baseView.mode != "create"
                ? {
                    menuItems: [
                      {
                        menuText: "Cancel",
                        disabled: this.isCancelMenuDisabled(),
                      },
                    ],
                    visible: true,
                    clickAction: (e) => {
                      if (e.itemData.menuText == "Cancel") {
                        this.cancelReceipt();
                      }
                    },
                  }
                : undefined,
            deliveryAddressItems: [
              {
                itemType: "group",
                caption: "",
                colCount: 1,
                items: [
                  {
                    dataField: "DeliveryAddressCompanyName",
                    editorType: "dxTextBox",
                    label: {
                      text: "Name",
                    },
                    // allowUpdate: false,
                  },
                  {
                    screenField: "PhysicalAddressStreetLine1",
                    dataField: "DeliveryAddressStreetLine1",
                    // allowUpdate: false,
                  },
                  {
                    screenField: "PhysicalAddressStreetLine2",
                    dataField: "DeliveryAddressStreetLine2",
                    // allowUpdate: false,
                  },
                  {
                    screenField: "PhysicalAddressSuburb",
                    dataField: "DeliveryAddressSuburb",
                    // allowUpdate: false,
                  },
                  {
                    screenField: "PhysicalAddressState",
                    dataField: "DeliveryAddressState",
                    // allowUpdate: false,
                  },
                  {
                    screenField: "PhysicalAddressPostcode",
                    dataField: "DeliveryAddressPostcode",
                    // allowUpdate: false,
                  },
                  {
                    screenField: "PhysicalAddressCountry",
                    dataField: "DeliveryAddressCountry",
                    // allowUpdate: false,
                  },
                ],
              },
            ],
          },
          formItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 3,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "DateIn",
                      dataField: "DateIn",
                      editorOptions: {
                        tabIndex: 2,
                        min: this.PaymentMinDate,
                        max: this.PaymentMaxDate,

                        allowUpdate: !this.isReviewMode(),
                        onValueChanged: (e) => {
                          this.DateInChanged(e);
                        },
                      },
                      label: {
                        text: "Date",
                      },
                      required: true,
                      validationRules: [
                        {
                          type: "required",
                          message: "Date is required",
                        },
                      ],
                    },
                    {
                      screenField: !this.isReviewMode()
                        ? "PaymentMethod"
                        : "Reference",
                      dataField: this.isReviewMode()
                        ? "PaymentMethod"
                        : "PaymentMethods",
                      required: true,
                      label: {
                        text: "Payment Method",
                      },
                      defaultValue: this.dataModel.PaymentMethod,
                      editorOptions: {
                        tabIndex: 3,
                        allowUpdate: !this.isReviewMode(),
                        onValueChanged: (e) => {
                          this.PaymentMethodsChanged(e);
                        },
                      },
                      dataSourceConfig: this.isReviewMode()
                        ? null
                        : {
                            data: this.dataModel.PaymentMethods,
                          },
                    },
                    {
                      screenField: "BankAccount",
                      required: true,
                      dataField: "BankAccountCode",
                      dataSourceConfig: this.isReviewMode()
                        ? undefined
                        : {
                            endpoint: "api/BankRecord",
                            sort: {
                              selector: "AccountName",
                              asc: true,
                            },
                            filter:
                              this.BaseCurrency == this.dataModel.Currency
                                ? [
                                    ["CurrencyCode", "=", this.BaseCurrency],
                                    "and",
                                    ["Inactive", "=", "N"],
                                  ]
                                : [
                                    [
                                      ["CurrencyCode", "=", this.BaseCurrency],
                                      "or",
                                      [
                                        "CurrencyCode",
                                        "=",
                                        this.dataModel.Currency,
                                      ],
                                    ],
                                    "and",
                                    ["Inactive", "=", "N"],
                                  ],
                            select: [
                              "CurrencyCode",
                              "Code",
                              "AccountName",
                              "AccountNo",
                              "AccountSearchText",
                              "ComputedCode",
                              "Inactive",
                            ],
                          },
                      // defaultValue: `${this.dataModel.BankAccountCode}`,
                      label: {
                        text: "Bank Account",
                      },
                      editorOptions: {
                        tabIndex: 4,
                        showClearButton: true,
                      },
                      validationRules: [
                        {
                          type: "required",
                          message:
                            "Please select Bank Account before attempting to save this receipt",
                        },
                      ],
                      displayExpr: (item) => {
                        if (item) return item.Code + " - " + item.AccountName;
                        else return "";
                      },
                      searchExpr: ["ComputedCode", "AccountName"],
                      itemTemplate: (data) => {
                        return ` <div class="custom-auto-complete" id="${data.Code}" >
                              <span class="auto-complete-primary">
                                ${data.AccountName}
                              </span>
                              <span class="record-secondary gc-grid-code">
                                ${data.Code}
                              </span> 
                            </div>`;
                      },
                    },
                    {
                      screenField: "Reference",
                      editorOptions: {
                        tabIndex: 5,
                        maxLength: 100,
                      },
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "Date",
                      dataField: "DueDate",
                      allowUpdate: true,
                      visible: !this.isReviewMode(),
                      label: {
                        text: "Due Date",
                      },
                      editorOptions: {
                        tabIndex: 6,
                        showClearButton: true,
                        onValueChanged: (e) => {
                          this.DueDateChanged(e);
                        },
                      },
                    },
                    // {
                    //   screenField: "Customer",
                    //   dataField: "Customer",
                    //   allowUpdate: false,
                    //   label: {
                    //     Text: "Customer",
                    //   },
                    //   editorOptions: {
                    //     tabIndex: -1,
                    //   },
                    // },
                    {
                      screenField: "Payer",
                      dataField: "Payer",
                      allowUpdate: true,
                      label: {
                        text: "Payer",
                      },
                      editorOptions: {
                        tabIndex: 7,
                        maxLength: 100,
                      },
                    },
                    {
                      itemType: "group",
                      caption: "",
                      colCount: 2,
                      items: [
                        {
                          dataField: "Currency",
                          allowUpdate: false,
                          label: {
                            text: "Currency",
                          },
                          editorOptions: {
                            tabIndex: -1,
                          },
                        },
                        {
                          screenField: "ExchangeRate",
                          dataField: "ExchangeRate",
                          required: true,
                          allowUpdate: this.dataModel.Currency != "AUD",
                          editorOptions: {
                            tabIndex: this.dataModel.Currency != "AUD" ? 8 : -1,
                            onValueChanged: (e) => {
                              if (e.value == 0) {
                                this.doValidation("Exchange rate Cannot be 0");

                                e.component.beginUpdate();
                                e.component.option("value", e.previousValue);
                                e.component.endUpdate();
                              } else this.onExchangeRateChange();
                            },
                          },
                          validationRules: [
                            {
                              type: "custom",
                              validationCallback: ({ value, rule }) => {
                                rule.message = `Exchange rate Cannot be 0 or Negative`;
                                return value > 0;
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  cssClass: "last-group ",
                  colCount: !this.isReviewMode() ? 3 : 2,
                  items: [
                    {
                      itemType: "group",
                      caption: "",
                      colCount: 1,
                      items: [
                        {
                          screenField: "FXAmount",
                          dataField: "FXAmount",
                          editorOptions: {
                            tabIndex: 9,
                            onValueChanged: (e) => {
                              this.fxAmountOnChanged(e);
                            },
                          },
                          label: {
                            text: "Amount (" + this.getCurrencyCode + ")",
                          },
                          validationRules: [
                            {
                              type: "required",
                              message: "Amount is required",
                            },
                          ],
                        },
                        {
                          screenField: "Rounding",
                          dataField: "FXVarianceRounding",
                          editorOptions: {
                            tabIndex: 10,
                            onValueChanged: (e) => {
                              this.fxRoundingOnChanged(e);
                            },
                          },

                          label: {
                            text: "Rounding (" + this.getCurrencyCode + ")",
                          },
                        },
                        {
                          screenField: "Total",
                          dataField: "AdjustmentAmount",
                          allowEditing: true,
                          editorOptions: {
                            tabIndex: 11,
                            onValueChanged: (e) => {
                              this.fxAdjustmentAmountOnChanged(e);
                            },
                          },
                          label: {
                            text: "Fee (" + this.getCurrencyCode + ")",
                          },
                        },
                        {
                          screenField: "Total",
                          dataField: "FXUnallocatedAmount",
                          allowEditing: true,
                          editorOptions: {
                            tabIndex: 12,
                            onValueChanged: (e) => {
                              this.fxUnallocatedAmountOnChanged(e);
                            },
                          },
                          label: {
                            text: "Unallocated (" + this.getCurrencyCode + ")",
                          },
                        },
                        // {
                        //   itemType: "group",
                        //   caption: "",
                        //   colCount: !this.isReviewMode() ? 2 : 1,
                        //   items: [
                        //     {
                        //       screenField: "Total",
                        //       type: "Decimal",
                        //       format: "Decimal-16-2",
                        //       dataField: "AdjustmentAmount",
                        //       allowEditing: true,
                        //       editorOptions: {
                        //         tabIndex: 11,
                        //         onValueChanged: (e) => {
                        //           this.feeValueChange(e);
                        //         },
                        //         readOnly: false,
                        //       },
                        //       label: {
                        //         text: "Fee (" + this.getCurrencyCode + ")",
                        //       },
                        //     },
                        //     {
                        //       screenField: "",
                        //       dataField: "edit",
                        //       cssClass:
                        //         "non-edit-cell-textbox-field-for-edit-bank-fee",
                        //       allowEditing: false,
                        //       editorOptions: {
                        //         onFocusIn: () => {
                        //           this.showBankFeeSettingsModal();
                        //         },
                        //         readOnly: true,
                        //       },
                        //       visible: !this.isReviewMode(),
                        //       label: {
                        //         text: "Edit",
                        //       },
                        //     },
                        //   ],
                        // },
                      ],
                    },
                    {
                      itemType: "group",
                      caption: "",
                      cssClass: "fee-group",
                      colCount: 1,
                      visible: !this.isReviewMode(),
                      items: [
                        {
                          screenField: "",
                          allowEditing: false,
                          cssClass: "fee-group-emply-field",
                          editorOptions: {
                            readOnly: true,
                          },
                        },
                        {
                          screenField: "",
                          allowEditing: false,
                          cssClass: "fee-group-emply-field",
                          editorOptions: {
                            readOnly: true,
                          },
                        },
                        {
                          screenField: "",
                          dataField: "edit",
                          cssClass:
                            "non-edit-cell-textbox-field-for-edit-bank-fee edit-button",
                          // allowEditing: false,
                          editorType: "dxButton",
                          editorOptions: {
                            onClick: () => {
                              this.showBankFeeSettingsModal();
                            },
                            // type: "default",
                            icon: "edit",
                            // readOnly: true,
                          },
                          // template: () => {
                          //   return "template";
                          // },
                          label: {
                            text: "Edit",
                            visible: false,
                          },
                        },
                      ],
                    },
                    {
                      itemType: "group",
                      caption: "",
                      colCount: 1,
                      items: [
                        {
                          screenField: "FXAmount",
                          dataField: "Amount",
                          editorOptions: {
                            tabIndex: 13,
                            onValueChanged: (e) => {
                              this.amountValueChange(e);
                            },
                          },
                          label: {
                            text: "Amount (" + this.getBaseCurrency + ")",
                          },
                          validationRules: [
                            {
                              type: "required",
                              message: "Amount is required",
                            },
                          ],
                        },
                        {
                          screenField: "Rounding",
                          dataField: "Rounding",
                          editorOptions: {
                            tabIndex: 14,
                            onValueChanged: (e) => {
                              this.roundingValueChange(e);
                            },
                          },

                          label: {
                            text: "Rounding (" + this.getBaseCurrency + ")",
                          },
                        },
                        {
                          screenField: "Total",
                          dataField: "BaseAdjustmentAmount",
                          allowEditing: true,
                          editorOptions: {
                            tabIndex: 15,
                            onValueChanged: (e) => {
                              this.adjustmentAmountValueChange(e);
                            },
                          },
                          label: {
                            text: "Fee (" + this.getBaseCurrency + ")",
                          },
                        },
                        {
                          screenField: "Total",
                          dataField: "UnallocatedAmount",
                          allowEditing: true,
                          editorOptions: {
                            tabIndex: 16,
                            onValueChanged: (e) => {
                              this.unallocatedValueChange(e);
                            },
                            onKeyDown: (e) => {
                              this.moveOnKeyDown(e);
                            },
                          },
                          label: {
                            text: "Unallocated (" + this.getBaseCurrency + ")",
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
          title: {
            createModeIsEditMode: true,
            primary: {
              primary: {
                dataField: this.baseView.mode == "create" ? undefined : "Code",
                text:
                  this.baseView.mode == "create"
                    ? "Create Customer Receipt "
                    : "Customer Receipt # ",
              },
              secondary: {
                dataField:
                  this.baseView.mode == "create" ? undefined : "CustomerName",
                text: this.baseView.mode == "create" ? undefined : " for ",
              },
            },
            secondary: {},
          },
        },
        gridData: {
          gridOptions: {
            dataSource: this.isReviewMode()
              ? {
                  // endpoint: "CashReceiptDetail",
                  // filter: ["CashReceiptCode eq " + this.baseView.id],
                  // serverPaging: true,
                  allowGrouping: false,
                  // expand: "SaleItem",
                  postProcessCallback: this.CashReceiptDetailPostProcess,
                  localDataList: true,
                  items: this.localDataSource._array,
                  local: true,
                }
              : {
                  // endpoint: this.dataModel.BillToCustomer
                  //   ? "OutstandingCustomerInvoice"
                  //   : undefined,
                  // filter: this.getGridFilter,
                  // serverPaging: true,
                  allowGrouping: false,
                  postProcessCallback:
                    this.createCustomerReceiptDetailPostProcess,
                  // key: "RefNoAsNumber",
                  // keyType: "Int32",

                  localDataList: true,
                  items: this.localDataSource._array,
                  local: true,
                },
            options: {
              dxPaging: false,
            },
            noDataMessage: {
              addNew: {
                class: "no-data",
                title: "No outstanding records",
                message:
                  "There are no outstanding records for the selected customer.",
              },
            },
          },
          toolbar: {
            search: true,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: true,
            review: false,
          },
          columns: [
            {
              screenField: "CheckInclude",
              allowEditing: false,
              defaultValue: false,
              valueChangeCallBack: this.checkBoxValueChange,
              allowHiding: false,
              showInColumnChooser: false,
              fixed: true,
              fixedPosition: "left",
              label: "",
              width: 50,
              minWidth: 50,
              visible: !this.isReviewMode(),
              cssClass: "check-include",
              allowSearch: false,
              makeDisabled: (cellInfo) => {
                if (
                  new Date(this.dataModel.DateIn) >=
                  new Date(cellInfo.data.DateInDate.replace("Z", ""))
                ) {
                  if (
                    !cellInfo.data.CheckInclude &&
                    cellInfo.data.Disabled == true &&
                    this.SelectedOnHeader != false
                  ) {
                    cellInfo.data.Disabled = false;
                    cellInfo.data.CheckInclude = true;
                    this.checkBoxValueChange(
                      {
                        event: true,
                        value: true,
                      },
                      cellInfo,
                    );
                  }
                  return false;
                } else {
                  if (cellInfo.data.CheckInclude) {
                    cellInfo.data.CheckInclude = false;
                    cellInfo.data.Disabled = true;
                    this.checkBoxValueChange(
                      {
                        event: true,
                        value: false,
                      },
                      cellInfo,
                    );
                  }
                  return true;
                }
              },
            },
            {
              screenField: "InvoiceType",
              dataField: "Type",
              label: "Type",
              width: ColumnWidth.InvoiceType.width,
              allowSearch: false,
            },
            {
              screenField: "Invoice",
              allowHiding: false,
              dataField: this.baseView.mode == "create" ? "RefNo" : "LinkRefNo",
              width: ColumnWidth.InvoiceRef.width,
              label: "Invoice / Ref",
              hyperlink: {
                url: "",
                dataField: "LinkRefNo",
                gridUrlDataFields: ["Type"],
                gridUrlConditions: [
                  {
                    values: [{ Type: "Invoice" }],
                    url: `invoice/review/__ID__`,
                  },
                  {
                    values: [{ Type: "Prepayment" }],
                    url: `customer-receipt/review/__ID__`,
                  },
                  {
                    values: [{ Type: "Unallocated" }],
                    url: `customer-receipt/review/__ID__`,
                  },
                ],
                target: "_blank",
              },
              allowSearch: true,
            },
            {
              screenField: "Date",
              label: "Date",
              minWidth: "auto",
              dataField: "DateIn",
              allowSearch: false,
            },
            {
              screenField: "Date",
              label: "Due Date",
              dataField: "CalculatedDueDate",
              // visible: !this.isReviewMode(),
              allowSearch: false,
            },
            {
              screenField: "SalesOrder",
              label: "Sales Order",
              dataField: "SalesOrder",
              width: ColumnWidth.SalesOrderNumber.width,
              hyperlink: {
                url: `sales-order/review/__ID__`,
                dataField: "SalesOrder",
                target: "_blank",
              },
              allowSearch: true,
            },
            {
              screenField: "CustPO",
              label: "Cust PO",
              dataField: "CustomerOrder",
              allowSearch: false,
              width: ColumnWidth.SalesOrderNumber.CustPO,
            },
            {
              screenField: "Comment",
              dataField: "Comment",
              allowSearch: false,
            },
            {
              screenField: "ExchangeRate",
              dataField:
                this.baseView.mode == "review" ? "FXRate" : "ExchangeRate",
              label: "Exchange Rate",
              format: "Decimal-6-4",
              type: "Decimal",
              width: ColumnWidth.ExchangeRate.width,
              allowSorting: true,
              showInColumnChooser: true,
              visible: true,
              allowSearch: false,
            },
            {
              screenField: "FXAmount",
              dataField: "FXAmount",
              visible: this.baseView.mode == "create",
              width: ColumnWidth.Amount.width,
              label: () => {
                return `Amount (${this.getCurrencyCode})`;
              },
              allowSearch: true,
            },
            {
              screenField: "FXBalance",
              type: "EditableDecimal",
              visible: this.baseView.mode == "create",
              width: ColumnWidth.Amount.width,
              label: () => {
                return `Balance (${this.dataModel.Currency})`;
              },
              allowSearch: true,
            },
            {
              screenField: "FXDiscount",
              dataField: "FXDiscount",
              type: "EditableDecimal",
              width: ColumnWidth.Amount.width,
              // visibleIndex: this.baseView.mode == "review" ? 8 : undefined,
              label: () => {
                return `Discount (${this.dataModel.Currency}) `;
              },
              showEditorAlways: this.baseView.mode == "create",
              value: 0,
              allowEditing: this.dataModel.Currency === "AUD" ? false : true,
              makeDisabled: (data) => {
                if (data.data.CheckInclude == true) {
                  return false;
                } else return true;
              },
              allowSearch: false,
              cssClass: "gc-editable-cell",
              onKeyDown: this.onFXDiscountKeyDown,
            },
            {
              screenField: "Discount",
              name: "Discount",
              dataField:
                this.baseView.mode == "review" ? "DiscAmount" : "Discount",
              format: "Decimal-16-2",
              type: "EditableDecimal",
              allowEditing: false,
              width: ColumnWidth.Amount.width,
              label: () => {
                return `Discount (${this.BaseCurrency})`;
              },
              visible: true,
              allowSearch: false,
            },
            {
              screenField: "FXAllocation",
              dataField: "FXAllocationAmount",
              allowEditing: this.baseView.mode != "review",
              type:
                this.baseView.mode != "review" ? "EditableDecimal" : "Decimal",
              showEditorAlways: this.baseView.mode == "create",
              width: ColumnWidth.Amount.width,
              // visibleIndex: this.baseView.mode == "review" ? 7 : undefined,
              label: () => {
                return `Allocated (${this.dataModel.Currency}) `;
              },
              value: (data) => {
                if (data.data.CheckInclude == false) {
                  data.data.Amount = 0;
                  return data.data.Amount;
                }
              },
              makeDisabled: (data) => {
                if (data.data.CheckInclude == true) {
                  return false;
                } else return true;
              },
              allowSearch: true,
            },
            {
              screenField: "Amount",
              dataField:
                this.baseView.mode == "review"
                  ? "Allocation"
                  : "AllocationAmount",
              format: "Decimal-16-2",
              type: "Decimal",
              allowEditing: false,
              width: ColumnWidth.Amount.width,
              label: () => {
                return `Allocated (${this.BaseCurrency})`;
              },
              visible: true,
              allowSearch: true,
            },
            {
              screenField: "Amount",
              name: "Gain / Loss",
              label: () => {
                return `Gain / Loss (${this.BaseCurrency})`;
              },

              dataField: "GainOrLoss",
              format: "Decimal-16-2",
              type: "Decimal",
              width: ColumnWidth.Amount.width,
              // visible: this.IsForeignCurrencyAccount,
              allowSearch: false,
            },
          ],

          valueChangedEventListners: [
            {
              dataField: "FXAllocationAmount",
              listner: (e, lineData) => {
                lineData.data.FXAllocationAmount = e.value;
                lineData.data.FXAllocation = e.value;

                lineData.data.FXAmount =
                  lineData.data.FXDiscount + lineData.data.FXAllocationAmount;

                lineData.data.AllocationAmount = FxToBaseCurrency(
                  e.value,
                  lineData.data.ExchangeRate,
                );

                lineData.data.GainOrLoss = this.calculateGainOrLoss(
                  lineData.data.FXAllocationAmount,
                  lineData.data.FXDiscount,
                  lineData.data.ExchangeRate,
                  this.dataModel.ExchangeRate,
                );

                this.mergeWithReviewView(
                  lineData.data.FXAllocationAmount == 0 ? false : true,
                  lineData.data,
                );
              },
            },
            {
              dataField: "FXDiscount",
              listner: (e, lineData) => {
                if (e.value >= 0) {
                  lineData.data.FXDiscount = e.value;
                  lineData.data.Discount = FxToBaseCurrency(
                    e.value,
                    lineData.data.ExchangeRate,
                  );
                  lineData.data.FXAllocationAmount =
                    lineData.data.FXBalance - e.value;

                  lineData.data.AllocationAmount =
                    lineData.data.Balance - lineData.data.Discount;

                  lineData.data.FXAmount =
                    lineData.data.FXDiscount + lineData.data.FXAllocationAmount;

                  lineData.data.GainOrLoss = this.calculateGainOrLoss(
                    lineData.data.FXAllocationAmount,
                    lineData.data.FXDiscount,
                    lineData.data.ExchangeRate,
                    this.dataModel.ExchangeRate,
                  );
                  this.mergeWithReviewView(
                    lineData.data.FXDiscount == 0 ? false : true,
                    lineData.data,
                  );
                } else {
                  lineData.data.FXDiscount = 0;
                  // this.validationSummary = [];
                  // this.validationSummary.push({
                  //   message: "Discount Cannot be Negative",
                  // });
                  this.doValidation("Discount Cannot be Negative");
                  this.mergeWithReviewView(
                    lineData.data.FXDiscount == 0 ? false : true,
                    lineData.data,
                  );
                }
              },
            },
          ],
        },
        footerData: {
          footerItems: [
            {
              screenField: "SalesUMItemCount",
              dataField: "SupplierRequired",
              location: "left",
              label: "Line Count",
              value: 0,
              // eslint-disable-next-line no-unused-vars
              customCalc: (headerData, gridItems) => {
                var count = 0;
                var items =
                  this.$refs["customer-receipt"].$refs[
                    "transactionGrid"
                  ].getLocalItemsList();
                items.forEach((element) => {
                  if (element.CheckInclude) count++;
                });

                return count;
              },
            },
            {
              screenField: "FXAllocation",
              location: "right",
              value: 0,
              dataField: "FXAllocationAmount",
              label: "Allocated (" + this.getCurrencyCode + ")",
              // eslint-disable-next-line no-unused-vars
              customCalc: (headerData, gridItems) => {
                var total = 0;

                if (this.baseView.mode == "review") {
                  // total = (
                  //   headerData.FXAmount - headerData.FXVarianceRounding
                  // ).roundNumber(2);

                  total = headerData.FXAllocatedAmount;
                } else {
                  var items =
                    this.$refs["customer-receipt"].$refs[
                      "transactionGrid"
                    ].getLocalItemsList();

                  items.forEach((element) => {
                    if (element.CheckInclude)
                      total = total + element.FXAllocationAmount;
                  });
                }
                return total;

                // return this.onCustomCalcAllocationAmountChanged(
                //   headerData,
                //   gridItems
                // );
              },
            },

            {
              screenField: "Total",
              dataField: "FXUnallocatedAmount",
              location: "right",
              label: "Unallocated (" + this.getCurrencyCode + ")",
              value: 0,
              allowEditing: false,
              customCalc: (headerData) => {
                return headerData.FXUnallocatedAmount;
              },
            },
            {
              screenField: "FXDiscount",
              dataField: "BalanceFX",
              location: "right",
              label: "Balance (" + this.getCurrencyCode + ")",
              value: 0,
              visible: this.baseView.mode != "review",
              allowEditing: false,
              // eslint-disable-next-line no-unused-vars
              customCalc: (headerData, gridItems) => {
                var Allocated = 0;
                var items =
                  this.$refs["customer-receipt"].$refs[
                    "transactionGrid"
                  ].getLocalItemsList();
                items.forEach((element) => {
                  if (element.CheckInclude)
                    Allocated = Allocated + element.FXAllocationAmount;
                });
                return (
                  headerData.FXAmount +
                  headerData.FXVarianceRounding -
                  headerData.FXUnallocatedAmount -
                  Allocated
                );
              },
            },
            {
              screenField: "FXDiscount",
              dataField: "FXDiscountAmount",
              location: "right",
              label: "Discount Applied (" + this.getCurrencyCode + ")",
              value: 0,
              allowEditing: false,
              // eslint-disable-next-line no-unused-vars
              customCalc: (headerData, gridItems) => {
                var total = 0;

                if (this.baseView.mode == "review") {
                  total = headerData.FXDiscAmount;
                } else {
                  var items =
                    this.$refs["customer-receipt"].$refs[
                      "transactionGrid"
                    ].getLocalItemsList();
                  items.forEach((element) => {
                    if (element.CheckInclude)
                      total = total + element.FXDiscount;
                  });
                }
                return total;
              },
            },
            // {
            //   screenField: "FXTotal",
            //   dataField: "FXTotal",
            //   location: "right",
            //   value: 0,
            //   customCalc: (headerData, gridItems) => {
            //     if (this.baseView.mode == "review") return headerData.FXAmount;

            //     var total = 0;
            //     gridItems.forEach((element) => {
            //       if (element.CheckInclude)
            //         total =
            //           total + element.FXAllocationAmount + element.FXDiscount;
            //     });
            //     return total;
            //   },
            //   label: "Amount (" + this.getCurrencyCode + ")",
            // },

            // {
            //   screenField: "Total",
            //   dataField: "Total",
            //   location: "right",
            //   value: 0,
            //   customCalc: (headerData, gridItems) => {
            //     if (this.baseView.mode == "review") return headerData.Amount;

            //     var total = 0;
            //     gridItems.forEach((element) => {
            //       if (element.CheckInclude)
            //         total = total + element.AllocationAmount + element.Discount;
            //     });
            //     return total;
            //   },
            //   label: "Amount (" + this.BaseCurrency + ") ",
            // },
            {
              screenField: "FXTotal",
              dataField: "Total",
              location: "right",
              value: 0,
              // eslint-disable-next-line no-unused-vars
              customCalc: (headerData, gridItems) => {
                var total = 0;
                var items =
                  this.$refs["customer-receipt"].$refs[
                    "transactionGrid"
                  ].getLocalItemsList();
                items.forEach((element) => {
                  if (element.CheckInclude) total = total + element.GainOrLoss;
                });
                return total;
              },
              label: `Gain / Loss (${this.BaseCurrency})`,
              name: "Gain / Loss (Base)",
              // visible: this.getCurrencyCode != this.BaseCurrency,
            },
          ],
        },
      };
      return screenJson;
    },
    getCurrencyCode() {
      if (this.dataModel.Currency) return this.dataModel.Currency;
      else return "";
    },

    getHeaderToolbar() {
      return {
        headerToolbar: {
          save: this.baseView.mode == "create",
          saveCallback: this.saveCustomerReceipt,
          customButtons: [
            {
              label: "save",
              icon: "..",
              type: " ",
              click: "",
              menu: [
                {
                  label: "Credit Comments",
                  clickAction: "",
                },
              ],
            },
          ],
        },
      };
    },

    getBaseCurrency() {
      return this.BaseCurrency;
    },
  },
  watch: {
    $route(to) {
      if (to.path == "/customer-receipt/create") {
        this.$store.dispatch("dataContext/setReviewDataSource", []);
        location.reload();
      }
    },
  },
  methods: {
    onFXDiscountKeyDown(e, cellInfo) {
      if (e.event.keyCode == 9 && e.event.shiftKey) {
        e.component.blur();
        if (cellInfo.rowIndex == 0) {
          setTimeout(() => {
            e.event.preventDefault();
          }, 1);
        }
        setTimeout(() => {
          var rowIndex = cellInfo.rowIndex;

          if (rowIndex == 0) {
            var headerFormInstance =
              this.$refs["customer-receipt"].$refs["gc-header-form-component"]
                .$refs["gc-header-form"].$refs["gc-form-comp"].instance;

            if (headerFormInstance) {
              headerFormInstance
                .getEditor("UnallocatedAmount")
                .instance()
                .focus();
              // setTimeout(() => {
              //   cellInfo.component.cancelEditData();
              // }, 5);
            }
          }
        }, 2);
      } else if (e.event.keyCode == 9) {
        cellInfo.component.editCell(cellInfo.rowIndex, 13);
      }
    },
    moveOnKeyDown(e) {
      if (e.event.keyCode == 9 && e.event.shiftKey == false) {
        e.event.preventDefault();
        setTimeout(() => {
          var dataGrid =
            this.$refs[
              "customer-receipt"
            ].$refs.transactionGrid.getGridInstance();

          if (dataGrid.getDataSource().items().length != 0) {
            dataGrid.editCell(0, 11);
          }
        }, 50);
      }
    },
    onHeaderFormContentReady(e) {
      // if (this.dataModel.CustomerCode) return;

      if (this.suppressHeaderFocus) {
        this.suppressHeaderFocus = false;
        return;
      }

      setTimeout(() => {
        let toolBarFormInstance = e.component;

        if (
          toolBarFormInstance &&
          toolBarFormInstance.getEditor("BillToCustomer")
        )
          toolBarFormInstance.getEditor("BillToCustomer").instance().focus();
      }, 500);
    },
    DueDateChanged(e) {
      if (!e.event) return;

      this.validationSummary = [];
      let year = new Date();

      if (e.value) year = e.value.getFullYear();
      if (e.value && year <= 1900) {
        this.dataModel.DueDate = e.previousValue;
        this.validationSummary.push({
          message: `You have entered an invalid date. Please re-enter a valid date.`,
        });
      } else {
        this.updateHeaderCheckBoxValue(false);
        this.$refs["customer-receipt"].$refs["transactionGrid"].showLoading(
          true,
        );

        // this.setLoading = true;
        this.$refs["customer-receipt"].$refs[
          "transactionGrid"
        ].clearLocalList();
        this.loadOutstandingCustomerInvoice(undefined, 0);
      }
    },
    fxAmountOnChanged(e) {
      if (!e.event) return;
      this.dataModel.FXAmount = e.value;
      this.dataModel.Amount = (
        e.value / this.dataModel.ExchangeRate
      ).round2Decimal();
      this.$store.dispatch(
        "dataContext/updateDataChangedIndex",
        this.dataChangedIndex++,
      );
    },
    fxRoundingOnChanged(e) {
      if (!e.event) return;
      this.dataModel.FXVarianceRounding = e.value;
      this.dataModel.Rounding = (
        e.value / this.dataModel.ExchangeRate
      ).round2Decimal();
      this.$store.dispatch(
        "dataContext/updateDataChangedIndex",
        this.dataChangedIndex++,
      );
    },
    fxAdjustmentAmountOnChanged(e) {
      if (!e.event) return;
      this.dataModel.AdjustmentAmount = e.value;
      this.dataModel.BaseAdjustmentAmount = (
        e.value / this.dataModel.ExchangeRate
      ).round2Decimal();
    },
    fxUnallocatedAmountOnChanged(e) {
      if (!e.event) return;
      this.dataModel.FXUnallocatedAmount = e.value;
      this.dataModel.UnallocatedAmount = (
        e.value / this.dataModel.ExchangeRate
      ).round2Decimal();
      this.$store.dispatch(
        "dataContext/updateDataChangedIndex",
        this.dataChangedIndex++,
      );
    },
    adjustmentAmountValueChange(e) {
      if (!e.event) return;
      this.dataModel.BaseAdjustmentAmount = e.value;
      this.dataModel.AdjustmentAmount = (
        e.value * this.dataModel.ExchangeRate
      ).round2Decimal();
    },
    unallocatedValueChange(e) {
      if (!e.event) return;
      this.dataModel.UnallocatedAmount = e.value;
      this.dataModel.FXUnallocatedAmount = (
        e.value * this.dataModel.ExchangeRate
      ).round2Decimal();
      this.$store.dispatch(
        "dataContext/updateDataChangedIndex",
        this.dataChangedIndex++,
      );
    },

    async cancelReceipt() {
      let confirmCancelReceipt = await this.$confirm(
        "Are you sure you want to cancel this receipt? This action cannot be undone.",
        "Cancel Receipt",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
        },
      );
      if (confirmCancelReceipt) {
        var cancelReceiptPayload = {
          Code: this.baseView.id,
          DateChanged: new Date(this.dataModel.DateChanged)
            .toISOString()
            .replace("Z", ""),
        };
        CustomerReceiptService.cancelReceipt(cancelReceiptPayload)

          .then(async (res) => {
            if (res)
              this.$notify(
                `Customer Receipt #${this.baseView.id} Cancelled Successfully`,
                "success",
              );

            this.setIgnoreRouteChangeConfirmation();
            const { from: parentPage } = this.baseView.query;
            await this.$router.push({
              path: `/customer-receipt/review/${res.data.CancellingReceiptCode}`,
              query: {
                from: parentPage,
              },
            });

            this.$router.go(0);
          })
          .catch((err) => {
            if (err) this.showLoading(false);
            this.$store.dispatch("ui/setServerError", {
              error: err,
              title: "Failed",
            });
          });
      }
      // .catch(() => {});
    },

    bankFeeValidationSummary() {
      let validationSummary = [];
      if (this.dataModel.AdjustmentAmount != 0) {
        if (
          this.dataModel.AdjustmentGLAccountCode == undefined ||
          this.dataModel.AdjustmentGLAccountCode == 0
        ) {
          validationSummary.push({
            message: "A bank fee must be associated with a GL Account.",
          });
        }
        if (this.dataModel.AdjustmentBranchCode == undefined) {
          validationSummary.push({
            message: "A bank fee must be associated with a Branch.",
          });
        }
        if (this.dataModel.AdjustmentDivisionCode == undefined) {
          validationSummary.push({
            message: "A bank fee must be associated with a Division",
          });
        }
      }
      return validationSummary;
    },
    showBankFeeSettingsModal() {
      this.bankFeePopupVisible = true;
    },
    bankFeeCallback(cancel, newBankFeeSettings) {
      if (cancel) {
        this.bankFeePopupVisible = false;
      } else if (!cancel && newBankFeeSettings) {
        this.bankFeePopupVisible = false;
        this.dataModel.AdjustmentGLAccountCode = newBankFeeSettings.GLAccount;
        this.dataModel.AdjustmentBranchCode = newBankFeeSettings.Branch;
        this.dataModel.AdjustmentDivisionCode = newBankFeeSettings.Division;
        this.dataModel.AdjustmentComment = newBankFeeSettings.Comment;
      }
    },
    doValidation(msg) {
      this.validationSummary = [];
      this.validationSummary.push({
        message: msg,
      });
    },
    DateInChanged(e) {
      if (!e.event) return;
      var value = e.value;
      this.validationSummary = [];
      if (this.PaymentMinDate < value && value < this.PaymentMaxDate) {
        this.dataModel.DateIn = value;

        this.$refs["customer-receipt"].$refs["transactionGrid"].gridRepaint();
      } else {
        this.dataModel.DateIn = e.previousValue;
        if (this.PaymentMinDate > value)
          this.validationSummary.push({
            message: `The date of this receipt is before the start of the first available accounting period. Please select a date on or after ${this.PaymentMinDate.toShortDateString()}.`,
          });

        if (value > this.PaymentMaxDate)
          this.validationSummary.push({
            message: `The date of this receipt is after the end of the last available accounting period. Please select a date on or before ${this.PaymentMaxDate.toShortDateString()}.`,
          });
      }

      if (this.IsSettlementDateEnforced == "Yes") {
        // eslint-disable-next-line no-unused-vars
        var items =
          this.$refs["customer-receipt"].$refs[
            "transactionGrid"
          ].getLocalItemsList();
        items = this.createCustomerReceiptDetailPostProcess(items);
      }
    },
    calculateGainOrLoss(
      fxAllocation,
      fxDiscount,
      receiptExchangeRate,
      invoiceExchangeRate,
    ) {
      return (
        (
          FxToBaseCurrency(fxAllocation + fxDiscount, receiptExchangeRate) -
          FxToBaseCurrency(fxAllocation + fxDiscount, invoiceExchangeRate)
        ).roundNumber(2) * -1
      );
    },
    CashReceiptDetailPostProcess(data) {
      data.forEach((element) => {
        element["RefNo"] = element.Invoice;
        element["DateIn"] = element.Date;
        if (element.Type == "Prepayment" || element.Type == "Unallocated")
          element["CalculatedDueDate"] = null;
        else element["CalculatedDueDate"] = element.DateChanged;
        // element["SalesOrder"] = element.SalesOrder;
        // element["CustomerOrder"] = element.CustomerOrder;
        // element["Balance"] = element.Balance;
        element["FXAllocationAmount"] = element.FXAllocation;
        element["GainOrLoss"] = element.FXVariance;
        element["CheckInclude"] = true;
      });
      return data;
    },
    isReviewMode() {
      return this.baseView.mode === "review";
    },
    isCancelMenuDisabled() {
      return (
        !FeatureStorage.checkPermission("CashReceipt", "create") ||
        this.dataModel.Status == "Cancelled" ||
        this.dataModel.Reconciled == "Y"
      );
    },
    cashReceiptPostProcess(data) {
      this.dataModel.Code = data.Code;
      this.dataModel.Reference = data.Reference;
      this.dataModel.PaymentMethod = data.PayMethod;
      this.dataModel.BankAccount = data.BankAccount;
      this.dataModel.BankAccountCode = `${data.BankAccount}`;
      this.dataModel.DateDeposited = data.Deposited;
      this.dataModel.DateIn = data.DateIn;
      this.dataModel.Customer = data.Customer.Name;
      this.dataModel.CustomerCode = data.CustomerCode;
      this.dataModel.Payer = data.PayeeName;
      this.dataModel.Currency = data.CurrencyCode;
      this.dataModel.ExchangeRate = data.FXRate;
      this.dataModel.FXIncTaxAmount = data.FXAmount;
      this.dataModel.FXVarianceRounding = data.Rounding;
      this.dataModel.Rounding = (
        data.Rounding / this.dataModel.ExchangeRate
      ).round2Decimal();

      this.dataModel.FXDiscAmount = data.FXDiscAmount;
      if (this.IsForeignCurrencyAccount) {
        this.dataModel.AdjustmentAmount = Math.abs(data.AdjustmentFXAmount);
      } else {
        this.dataModel.AdjustmentAmount = Math.abs(data.AdjustmentAmount);
      }
      this.dataModel.FXAmount = data.FXAmount;
      this.dataModel.Amount = data.Amount;
      this.dataModel.Status = data.FriendlyStatus;
      this.dataModel.CustomerName = data.PayeeName
        ? data.PayeeName
        : data.Customer.Name;

      this.dataModel.DateCreated = data.DateCreated;

      this.dataModel.DateChanged = data.DateChanged;
      this.dataModel.CreatedBy = data.CreatedBy;
      this.dataModel.ChangedBy = data.CreatedBy;

      this.dataModel.UnallocatedAmount = data.UnallocatedAmount;
      this.dataModel.FXUnallocatedAmount = data.FXUnallocatedAmount;
      this.dataModel.AllocatedAmount = data.AllocatedAmount;
      this.dataModel.FXAllocatedAmount = data.FXAllocatedAmount;
      this.dataModel.Reconciled = data.Reconciled;

      return data;
    },
    PaymentMethodsChanged({ value }) {
      this.suppressHeaderFocus = true;
      this.dataModel.PaymentMethod = value;
    },
    onExchangeRateChange() {
      // var dataGrid =
      //   this.$refs["customer-receipt"].$refs.transactionGrid.getGridInstance();

      let items =
        this.$refs["customer-receipt"].$refs[
          "transactionGrid"
        ].getLocalItemsList();

      items.forEach((record) => {
        if (this.dataModel.ExchangeRate > 0)
          record.GainOrLoss = this.calculateGainOrLoss(
            record.FXAllocationAmount,
            record.FXDiscount,
            record.ExchangeRate,
            this.dataModel.ExchangeRate,
          );
        else record.GainOrLoss = 0;
      });

      if (this.dataModel.ExchangeRate > 0) {
        this.dataModel.Amount = (
          this.dataModel.FXAmount / this.dataModel.ExchangeRate
        ).round2Decimal();
        this.dataModel.Rounding = (
          this.dataModel.FXVarianceRounding / this.dataModel.ExchangeRate
        ).round2Decimal();
        this.dataModel.UnallocatedAmount = (
          this.dataModel.FXUnallocatedAmount / this.dataModel.ExchangeRate
        ).round2Decimal();
        this.dataModel.BaseAdjustmentAmount = (
          this.dataModel.AdjustmentAmount / this.dataModel.ExchangeRate
        ).round2Decimal();
      } else {
        this.dataModel.FXAmount = 0;
        this.dataModel.FXVarianceRounding = 0;
        this.dataModel.FXUnallocatedAmount = 0;
        this.dataModel.AdjustmentAmount = 0;
        this.dataModel.Amount = 0;
        this.dataModel.Rounding = 0;
        this.dataModel.UnallocatedAmount = 0;
        this.dataModel.BaseAdjustmentAmount = 0;
      }

      this.$store.dispatch(
        "dataContext/updateDataChangedIndex",
        this.dataChangedIndex++,
      );
    },
    onCustomCalcBalance(headerData, gridItems) {
      var total = 0;
      gridItems.forEach((element) => {
        if (element.CheckInclude) total = total + element.FXAllocationAmount;
      });
      total = headerData.FXAmount - (total + headerData.FXVarianceRounding);
      this.dataModel.footerBalance = total;
      return total;
    },
    onCustomCalcAllocationAmountChanged(headerData, gridItems) {
      var total = 0;
      gridItems.forEach((element) => {
        if (element.CheckInclude) total = total + element.FXAllocationAmount;
      });
      this.dataModel.footerAllocated = total;
      return total;
    },
    isNavigatedFromCustomerPage() {
      const { from } = this.baseView.query;
      return (
        from == "customer-list" ||
        from == "customer-detail" ||
        !this.baseView.id
      );
    },
    getTotalOfGridFields(gridItems, propertyName) {
      var total = 0;
      gridItems.forEach((element) => {
        if (element.CheckInclude) total = total + element[propertyName];
      });
      return total;
    },
    async onCustomerCodeItemClicked(e) {
      this.localDataSource.clear();

      if (!e.itemData) {
        this.$refs["customer-receipt"].$refs[
          "transactionGrid"
        ].clearLocalList();
      }

      var data = e.itemData;

      if (data) {
        this.dataModel.CustomerCode = data.Code;
        this.dataModel.CurrencyCode = data.CurrencyCode;

        this.dataModel.BillToCustomer = data.Code;
        this.dataModel.Currency = data.CurrencyCode;
        this.dataModel.Customer = data.Name;
        this.dataModel.Payer = data.Name;
      } else {
        this.dataModel.Payer = "";
      }

      if (data && data.CurrencyCode) {
        await ForeignCurrencyService.getByCode(data.CurrencyCode).then(
          (res) => {
            this.dataModel["ExchangeRate"] = res.data.value[0].BuyRate;
          },
        );
        // this.setDeliveryAddressDataSourceItems(data.Code, 1);
      } else {
        this.dataModel["ExchangeRate"] = 1;
      }

      // if (data.BillToCustomerCode == data.Code) {
      // } else {
      //   await CustomerService.getByCode(data.BillToCustomerCode)
      //     .then((res) => {
      //       this.dataModel.Customer = res.data.value[0].Name;
      //       this.dataModel.Payer = res.data.value[0].Name;
      //     })
      //     .catch();
      // }

      setTimeout(() => {
        // this.setLoading = true;
        this.$refs["customer-receipt"].$refs["transactionGrid"].showLoading(
          true,
        );
        this.$refs["customer-receipt"].$refs[
          "transactionGrid"
        ].clearLocalList();
        this.loadOutstandingCustomerInvoice(undefined, 0);
      }, 10);
    },
    async loadOutstandingCustomerInvoice(total, skip) {
      this.setLoading = true;
      this.$refs["customer-receipt"].$refs["transactionGrid"].showLoading(true);
      if (!total || skip < total) {
        await CustomerReceiptService.getOutstandingCustomerInvoice({
          filter: this.getGridFilter,
          select: [
            "ArdataCode",
            "Balance",
            "CalculatedDueDate",
            // "CalculatedDueDateString",
            "Currency",
            "CustomerBillToCode",
            "CustomerCode",
            "CustomerName",
            "CustomerOrder",
            // "CustomerTypeDiscountAmount",
            // "CustomerTypeDiscountPcnt",
            // "CustomerTypeFXDiscountAmount",
            "DateIn",
            "DiscountReceived",
            "ExchangeRate",
            "FXBalance",
            "FXDiscountReceived",
            // "FXInvoiceSettlementDiscountAmount",
            // "FXReceiptSettlementDiscountAmount",
            "InvoiceSettlementDiscountAmount",
            // "IsReadOnly",
            // "IsRefNoANumber",
            // "ReceiptSettlementDiscountAmount",
            "RefNo",
            "RefNoAsNumber",
            "SalesOrder",
            "Type",
            "Comment",
            "LinkRefNo",
            "DateInDate",
          ],
          count: true,
          skip: skip,
          top: 1000,
        })
          .then((rslt) => {
            // this.setLoading = false;
            if (!total) total = rslt.data["@odata.count"];
            if (rslt.data.value.length > 0) {
              // rslt.data.value.forEach((element, index) => {
              //   element.ID = index;
              //   this.localDataSource.insert(element);
              // });

              this.$refs["customer-receipt"].$refs[
                "transactionGrid"
              ].addItemToLocalList(
                this.createCustomerReceiptDetailPostProcess(rslt.data.value),
              );
            }

            if (total > 0) {
              // this.setLoading = true;
              this.loadOutstandingCustomerInvoice(total, skip + 1000);
            } else {
              this.$refs["customer-receipt"].$refs[
                "transactionGrid"
              ].showLoading(false);
              this.updateHeaderCheckBox(
                this.$refs["customer-receipt"].$refs[
                  "transactionGrid"
                ].getLocalItemsList(),
              );
              this.setLoading = false;
            }
          })
          .catch((err) => {
            this.$refs["customer-receipt"].$refs["transactionGrid"].showLoading(
              false,
            );
            this.setLoading = false;
            this.$store.dispatch("ui/setServerError", {
              error: err,
              title: "Failed",
            });
          });
      } else {
        setTimeout(() => {
          this.$refs["customer-receipt"].$refs["transactionGrid"].showLoading(
            false,
          );

          this.setLoading = false;
        }, 100);
      }

      if (this.loaded) {
        // this.$refs["customer-receipt"].$refs["transactionGrid"].setDataSource(
        //   this.createCustomerReceiptDetailPostProcess(
        //     this.localDataSource._array
        //   )
        // );
        // this.$refs["customer-receipt"].$refs["transactionGrid"].gridRepaint();
        // setTimeout(() => {
        //   this.$store.dispatch(
        //     "dataContext/updateDataChangedIndex",
        //     this.dataChangedIndex++
        //   );
        // }, 50);
      }
    },

    isValidData(response) {
      return (
        response &&
        response.data &&
        Array.isArray(response.data.value) &&
        response.data.value.length > 0
      );
    },
    async getDefaultSettings() {
      try {
        const response = await retryAsync(() =>
          DefaultCompanyBranchDivisionService.getDefault(),
        );
        if (this.isValidData(response)) {
          const defaultSettings = response.data.value[0];
          this.dataModel.BranchCode = defaultSettings.BranchCode;
          this.dataModel.CompanyCode = defaultSettings.CompanyCode;
          this.dataModel.DivisionCode = defaultSettings.DivisionCode;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error fetching default settings:", error);
      }
    },
    async getCompanyData() {
      try {
        const response = await retryAsync(() =>
          CompanyService.getCompanyCurrencyData(this.dataModel.CompanyCode),
        );
        if (this.isValidData(response)) {
          const companyDetails = response.data.value[0];
          this.BaseCurrency = companyDetails.CurrencyCode;
          this.dataModel.ExchangeRate = companyDetails.BuyRate;
        } else {
          this.BaseCurrency = "AUD";
          this.dataModel.ExchangeRate = 1.0;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error fetching company data:", error);
      }
    },
    async getCurrentAccountingPeriodCode() {
      try {
        const response = await retryAsync(() =>
          CustomerReceiptService.getCurrentAccountingPeriodCode(),
        );
        if (this.isValidData(response)) {
          this.dataModel.AccountingPeriodCode =
            response.data.value[0].AccountingPeriodCode;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error fetching current accounting period code:", error);
      }
    },
    async getCustomerByCode() {
      try {
        const response = await retryAsync(() =>
          CustomerService.getByCode(this.baseView.id, [
            "Code",
            "BillToCustomerCode",
            "CurrencyCode",
            "Name",
          ]),
        );

        if (this.isValidData(response)) {
          const customerData = response.data.value[0];
          this.dataModel.BillToCustomer = customerData.BillToCustomerCode;
          this.dataModel.CustomerCode = customerData.Code;
          this.dataModel.Currency = customerData.CurrencyCode;

          if (customerData.BillToCustomerCode === customerData.Code) {
            this.dataModel.Customer = customerData.Name;
            this.dataModel.Payer = customerData.Name;
          } else {
            const billToCustomerResponse = await CustomerService.getByCode(
              customerData.BillToCustomerCode,
              ["Code", "Name"],
            );
            if (this.isValidData(billToCustomerResponse)) {
              const billToCustomerData = billToCustomerResponse.data.value[0];
              this.dataModel.Customer = billToCustomerData.Name;
              this.dataModel.Payer = billToCustomerData.Name;
            }
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error fetching customer by code:", error);
      }
    },
    async getInvoiceByInvoiceCode() {
      try {
        const response = await retryAsync(() =>
          CustomerInvoiceService.getInvoiceByInvoiceCode(
            this.baseView.query.invoiceNumber,
            [
              "CustomerCode",
              "BillToCustomerCode",
              "CurrencyCode",
              "DeliveryAddressCompanyName",
            ],
          ),
        );

        if (this.isValidData(response)) {
          const invoiceData = response.data.value[0];
          this.dataModel.BillToCustomer = invoiceData.BillToCustomerCode;
          this.dataModel.CustomerCode = invoiceData.CustomerCode;
          this.dataModel.Currency = invoiceData.CurrencyCode;

          if (invoiceData.BillToCustomerCode === invoiceData.CustomerCode) {
            this.dataModel.Customer = invoiceData.Name;
            this.dataModel.Payer = invoiceData.DeliveryAddressCompanyName;
          } else {
            const billToCustomerResponse = await retryAsync(() =>
              CustomerService.getByCode(invoiceData.BillToCustomerCode, [
                "Code",
                "Name",
              ]),
            );

            if (this.isValidData(billToCustomerResponse)) {
              const billToCustomerData = billToCustomerResponse.data.value[0];
              this.dataModel.Customer = billToCustomerData.Name;
              this.dataModel.Payer = billToCustomerData.Name;
            }
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error fetching invoice by code:", error);
      }
    },

    async getBankSettingDefaults() {
      try {
        const response = await retryAsync(() =>
          BankFeeSettings.getDefaultSettings(),
        );
        if (response && response.GLAccount) {
          this.dataModel.AdjustmentGLAccountCode = response.GLAccount;
        }
        this.dataModel.AdjustmentBranchCode = getFactorByCode(666).Factorc;
        this.dataModel.AdjustmentDivisionCode = getFactorByCode(667).Factorc;
        this.dataModel.AdjustmentComment = getFactorByCode(668).Factorc;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error fetching bank setting defaults:", error);
      }
    },

    async getPaymentMethods(IsReview = false) {
      try {
        const response = await retryAsync(() =>
          CustomerReceiptService.getPaymentMethods([
            "Inactive",
            "PayDesc",
            "PayType",
            "Rank",
            "isDefault",
          ]),
        );

        this.dataModel.PaymentMethods = response.data.value;
        if (!IsReview) {
          const defaultMethod = response.data.value.find(
            (val) => val.isDefault === 1,
          );
          if (defaultMethod) {
            this.dataModel.PaymentMethod = defaultMethod.PayType;
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error fetching payment methods:", error);
      }
    },
    async getByCurrencyCode() {
      try {
        const response = await retryAsync(() =>
          CompanyCurrencyService.getByCurrencyCode(this.dataModel.Currency, {
            select: ["CurrencyCode", "BuyRate"],
          }),
        );

        if (this.isValidData(response)) {
          this.dataModel.ExchangeRate = response.data.value[0].BuyRate;
        } else {
          this.dataModel.ExchangeRate = 1.0;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error fetching currency by code:", error);
      }
    },

    async getCashReceiptDetail() {
      try {
        const response = await retryAsync(() =>
          CustomerReceiptService.getCashReceiptDetail({
            filter: ["CashReceiptCode eq " + this.baseView.id],
          }),
        );

        if (this.isValidData(response)) {
          const cashReceiptData = response.data.value;
          cashReceiptData.forEach((element, index) => {
            element.ID = index;
            this.localDataSource.insert(element);
          });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error fetching cash receipt detail:", error);
      }
    },

    async initialized() {
      this.InvoiceNumber = this.baseView.query.invoiceNumber;
      this.setLoading = true;

      if (!this.isReviewMode()) {
        try {
          // STEP 1 — Must be first: Get factors
          try {
            await this.$store.dispatch(
              "screenFactors/getFactors",
              [237, 540, 666, 667, 668],
            );
            const factor237 = getFactorByCode(237);
            if (factor237 && factor237.FactorInt) {
              this.dataModel.BankAccountCode = factor237.FactorInt.toString();
            }
            const factor540 = getFactorByCode(540);
            if (factor540) {
              this.IsSettlementDateEnforced = factor540.Factorc;
            }
          } catch (e) {
            // eslint-disable-next-line no-console
            console.error("Failed to fetch factors", e);
          }

          // Get default settings
          await this.getDefaultSettings();

          // STEP 2 — Parallel requests (safe)
          await Promise.allSettled([
            this.getCompanyData(),
            this.getCurrentAccountingPeriodCode(),
            this.getBankSettingDefaults(),
            this.getPaymentMethods(),
          ]);

          // STEP 3 — Conditional calls
          if (this.isNavigatedFromCustomerPage() && this.baseView.id) {
            await this.getCustomerByCode();
          } else if (this.baseView.id && this.baseView.query.invoiceNumber) {
            await this.getInvoiceByInvoiceCode();
          }

          // STEP 4 — Currency update
          if (!this.dataModel.CustomerCode) {
            this.dataModel.Currency = this.BaseCurrency;
          }

          if (
            this.dataModel.Currency &&
            this.BaseCurrency !== this.dataModel.Currency
          ) {
            await this.getByCurrencyCode();
          }

          // STEP 5 — Final setup
          await this.setDateInValidation();
          this.loaded = true;

          setTimeout(() => {
            if (this.dataModel.BillToCustomer !== undefined) {
              this.setLoading = false;
              this.$refs["customer-receipt"].$refs[
                "transactionGrid"
              ].showLoading(true);
              this.loadOutstandingCustomerInvoice(undefined, 0);
            } else {
              this.setLoading = false;
            }
          }, 100);
        } catch (error) {
          this.$logger.debug("error", error);
        }
      } else {
        // REVIEW MODE
        await this.getPaymentMethods(true);
        await this.getCashReceiptDetail();
        this.$nextTick(() => {
          setTimeout(() => {
            this.reload = false;
            this.loaded = true;
            this.setLoading = false;
          }, 250);
        });
      }
    },
    async setDateInValidation() {
      var currentPaymentDate = undefined;
      if (this.isReviewMode())
        currentPaymentDate = new Date(this.dataModel.DateInto.replace("Z", ""));
      else currentPaymentDate = this.PaymentMinDate;

      CustomerReceiptService.getActiveAccountingPeriodStartAndEndDate().then(
        (res) => {
          if (res) {
            let accountingPeriodStartDate = new Date(
              res.data.value[0].StartDate.replace("Z", ""),
            );

            if (
              this.isReviewMode() &&
              currentPaymentDate.getTime() > accountingPeriodStartDate.getTime()
            ) {
              this.PaymentMinDate = currentPaymentDate;
            } else {
              this.PaymentMinDate = accountingPeriodStartDate;
            }

            this.PaymentMaxDate = new Date(
              res.data.value[0].EndDate.replace("Z", ""),
            );
          } else {
            this.PaymentMinDate = currentPaymentDate;
          }

          var gcForm =
            this.$refs["customer-receipt"].$refs["gc-header-form-component"]
              .$refs["gc-header-form"];

          let dateIn = new Date(this.dataModel.DateIn);
          let minDate = new Date(this.PaymentMinDate);
          let maxDate = new Date(this.PaymentMaxDate);

          if (dateIn < minDate) {
            this.dataModel.DateIn = this.PaymentMinDate;
            if (gcForm) {
              gcForm.updateFieldValue("DateIn", this.dataModel.DateIn);
              gcForm.validateForm();
            }
          } else if (dateIn > maxDate) {
            this.dataModel.DateIn = this.PaymentMaxDate;
            if (gcForm) {
              gcForm.updateFieldValue("DateIn", this.dataModel.DateIn);
              gcForm.validateForm();
            }
          }
        },
      );
    },

    checkBoxValueChange(fieldData, recordData) {
      if (!fieldData.event) return;

      var gridItems =
        this.$refs["customer-receipt"].$refs[
          "transactionGrid"
        ].getLocalItemsList();
      var dataGrid = recordData.component.instance();

      if (recordData.rowType == "header") {
        if (fieldData.value == undefined) return;
        else {
          if (fieldData.value == true) {
            var selectedItems = gridItems.filter((x) => x.CheckInclude);
            var disabledItems = gridItems.filter((x) => x.Disabled);
            if (
              selectedItems.length ==
              gridItems.length - disabledItems.length
            ) {
              fieldData.value = false;
            }
          }

          this.updateHeaderCheckBoxValue(fieldData.value);

          if (fieldData.value)
            gridItems = this.createCustomerReceiptDetailPostProcess(
              gridItems,
              false,
            );

          for (let index = 0; index < gridItems.length; index++) {
            var element = gridItems[index];
            element.CheckInclude = fieldData.value;
            if (!fieldData.value) {
              element.CheckInclude = false;
              element.FXAllocationAmount = 0.0;
              element.AllocationAmount = 0.0;
              element.FXDiscount = 0.0;
              element.Discount = 0.0;
            }
            this.mergeWithReviewView(fieldData.value, element);
            // var rowIndex = dataGrid.getRowIndexByKey(element);
            // if (rowIndex != -1) dataGrid.repaintRows([rowIndex]);
          }
        }
      } else {
        recordData.data.CheckInclude = fieldData.value;
        if (fieldData.value) {
          var data = this.createCustomerReceiptDetailPostProcess(
            [recordData.data],
            false,
          );
          recordData.data = data[0];
        } else {
          recordData.data.FXAllocationAmount = 0;
          recordData.data.AllocationAmount = 0;
          recordData.data.FXDiscount = 0;
          recordData.data.Discount = 0;
          recordData.data.GainOrLoss = this.calculateGainOrLoss(
            recordData.data.FXAllocationAmount,
            recordData.data.FXDiscount,
            recordData.data.ExchangeRate,
            this.dataModel.ExchangeRate,
          );
        }

        dataGrid.repaintRows([recordData.rowIndex]);
        this.mergeWithReviewView(fieldData.value, recordData.data);
        this.updateHeaderCheckBox(gridItems);
      }

      this.$store.dispatch(
        "dataContext/updateDataChangedIndex",
        this.dataChangedIndex++,
      );
      this.$refs["customer-receipt"].$refs["transactionGrid"].gridRepaint();
    },

    mergeWithReviewView(value, item) {
      var index = this.reviewDataSource.findIndex(
        (x) => x.GoodsInCode == item.GoodsInCode && x.ItemCode == item.ItemCode,
      );
      if (!value) {
        if (index != -1) {
          this.removeFromReview(index);
        }
      } else {
        if (index != -1) {
          this.removeFromReview(index);
        }
        this.addToReview(item);
      }
    },

    removeFromReview(index) {
      this.reviewDataSource.splice(index, 1);
      this.$store.dispatch(
        "dataContext/setReviewDataSource",
        this.reviewDataSource,
      );
    },

    addToReview(item) {
      item.CheckInclude = true;
      this.reviewDataSource.push(item);
      this.$store.dispatch(
        "dataContext/setReviewDataSource",
        this.reviewDataSource,
      );
    },

    updateHeaderCheckBox(gridItems) {
      let count = 0;
      gridItems =
        this.$refs["customer-receipt"].$refs[
          "transactionGrid"
        ].getLocalItemsList();
      gridItems.forEach((element) => {
        if (element.CheckInclude) count = count + 1;
      });

      setTimeout(() => {
        if (count > 0 && count != gridItems.length) {
          // getInstanceHeader.option("value", undefined);
          this.updateHeaderCheckBoxValue(undefined);
        } else if (count == 0) {
          // getInstanceHeader.option("value", false);
          this.updateHeaderCheckBoxValue(false);
        } else if (count == gridItems.length) {
          // getInstanceHeader.option("value", true);
          this.updateHeaderCheckBoxValue(true);
        }
      }, 100);
    },
    updateHeaderCheckBoxValue(value) {
      var refHeadInstance =
        this.$refs["customer-receipt"].$refs["transactionGrid"].$refs[
          "cx-CheckInclude"
        ].getSeletcAllRef().instance;
      refHeadInstance.blur();
      var checkBoxHeader = refHeadInstance.element();
      var getInstanceHeader = CheckBox.getInstance(checkBoxHeader);
      getInstanceHeader.option("value", value);
      this.SelectedOnHeader = value;
    },
    roundingValueChange(e) {
      if (!e.event) return;
      this.dataModel.Rounding = e.value;
      this.dataModel.FXVarianceRounding = (
        e.value * this.dataModel.ExchangeRate
      ).round2Decimal();
      this.$store.dispatch(
        "dataContext/updateDataChangedIndex",
        this.dataChangedIndex++,
      );
    },
    feeValueChange(e) {
      this.dataModel.Fee = e.value;
      this.$store.dispatch(
        "dataContext/updateDataChangedIndex",
        this.dataChangedIndex++,
      );
    },
    amountValueChange(e) {
      if (!e.event) return;
      this.dataModel.Amount = e.value;
      this.dataModel.FXAmount = (
        e.value * this.dataModel.ExchangeRate
      ).round2Decimal();
      this.$store.dispatch(
        "dataContext/updateDataChangedIndex",
        this.dataChangedIndex++,
      );
    },

    async saveCustomerReceipt(data, gridItems) {
      gridItems =
        this.$refs["customer-receipt"].$refs[
          "transactionGrid"
        ].getLocalItemsList();
      var payload = {
        AccountPeriod: data.AccountingPeriodCode,
        Currency: data.Currency,
        PaymentMethod: data.PaymentMethod ? data.PaymentMethod : "",
        PayeeName: data.Payer,
        DateIn: new Date(data.DateIn).toSaveDate(),
        Reference: data.Reference,
        Rounding: data.FXVarianceRounding,
        CustomerCode: this.dataModel.BillToCustomer,
        FXAmount: data.FXAmount,
        Amount: FxToBaseCurrency(data.FXAmount, data.ExchangeRate),
        CompanyCode: this.dataModel.CompanyCode,
        BranchCode: this.dataModel.BranchCode,
        DivisionCode: this.dataModel.DivisionCode,
        BankAccountCode: this.dataModel.BankAccountCode,
        AdjustmentGLAccountCode: parseInt(
          this.dataModel.AdjustmentGLAccountCode,
        ),
        AdjustmentFXAmount: this.dataModel.AdjustmentAmount,
        AdjustmentBranchCode: this.dataModel.AdjustmentBranchCode,
        AdjustmentDivisionCode: this.dataModel.AdjustmentDivisionCode,
        AdjustmentComment: this.dataModel.AdjustmentComment,
        ChequeNo: "",
        BSBNO: "",
        AccountNumber: "",
        FXRate: data.ExchangeRate,
        Deposited: data.DateDeposited,
        CustomerReceiptDetails: [],
        UnallocatedAmount: data.UnallocatedAmount,
        FXUnallocatedAmount: data.FXUnallocatedAmount,
      };
      gridItems.forEach((el) => {
        if (!el.CheckInclude) return;
        let obj = {
          Include: "Y",
          CalculateDiscount: this.IsSettlementDateEnforced,
          ARDataXref: String(el.ArdataCode),
          CustomerInvoice: el.RefNo,
          SalesOrder: parseInt(el.SalesOrder),
          CustomerOrder: el.CustomerOrder,
          InvoiceDate: new Date(el.DateIn).toSaveDate(),
          FXRate1: el.ExchangeRate,
          FXVar:
            parseFloat(data.ExchangeRate) == parseFloat(el.ExchangeRate)
              ? 0
              : (parseFloat(el.FXBalance) == parseFloat(el.FXAllocationAmount)
                  ? (
                      el.FXAllocationAmount.roundNumber(2) / data.ExchangeRate
                    ).roundNumber(2) - el.Balance
                  : (
                      el.FXAllocationAmount.roundNumber(2) / data.ExchangeRate
                    ).roundNumber(2) -
                    (
                      el.FXAllocationAmount.roundNumber(2) / el.ExchangeRate
                    ).roundNumber(2)
                ).roundNumber(2),
          FXAllocation: el.FXAllocationAmount.roundNumber(2),
          Allocation:
            parseFloat(el.FXBalance) == parseFloat(el.FXAllocationAmount)
              ? el.Balance
              : (
                  el.FXAllocationAmount.roundNumber(2) / el.ExchangeRate
                ).roundNumber(2),
          Currency: el.Currency,
          FXBalance: el.FXBalance,
          Balance:
            parseFloat(data.ExchangeRate) == parseFloat(el.ExchangeRate)
              ? el.Balance
              : (
                  (el.FXBalance.roundNumber(2) - el.FXDiscount.roundNumber(2)) /
                  data.ExchangeRate
                ).roundNumber(2),
          FXDiscount: el.FXDiscount,
          DiscountAmount: FxToBaseCurrency(el.FXDiscount, data.ExchangeRate),
        };
        payload.CustomerReceiptDetails.push(obj);
      });

      payload.VarianceAmount = payload.CustomerReceiptDetails.reduce(
        (prev, curr) => prev + curr.FXVar,
        0.0,
      );

      payload.FXDiscount = payload.CustomerReceiptDetails.reduce(
        (prev, curr) => prev + curr.FXDiscount,
        0.0,
      );

      payload.DiscountAmount = FxToBaseCurrency(
        payload.FXDiscount,
        data.ExchangeRate,
      );

      var total = 0;
      gridItems.forEach((element) => {
        if (element.CheckInclude) {
          total = (total + element.FXAllocationAmount).roundNumber(4);
        }
      });
      var footerbalance = (
        (payload.FXAmount + data.FXVarianceRounding).roundNumber(2) -
        (payload.FXUnallocatedAmount + total).roundNumber(2)
      ).roundNumber(2);

      this.validationSummary = [];
      this.validationSummary = this.bankFeeValidationSummary();

      if (this.validationSummary.length > 0) return;

      if (payload.PaymentMethod === "") {
        this.validationSummary.push({
          message: "Payment Method is Required",
        });
        return;
      }
      if (
        payload.CustomerReceiptDetails.length === 0 &&
        payload.FXUnallocatedAmount == 0
      ) {
        this.validationSummary.push({
          message:
            "Customer Receipt has no detail. Please include one or more invoices before attempting to save the transaction again.",
        });
        return;
      } else if (footerbalance != 0) {
        this.validationSummary.push({
          message:
            "Customer Receipt must balance to 0.00. Please check the amount received and the sum of the invoices included in the receipt before attempting to save the transaction again.",
        });
        return;
      }
      this.setLoading = true;
      await CustomerReceiptService.saveCustomerReceipt(payload)
        .then(({ data }) => {
          if (data) this.setLoading = false;
          this.$notify(
            `Customer Receipt ${data.Code} saved successfully`,
            "success",
          );
          this.setIgnoreRouteChangeConfirmation();
          const { from: parentPage } = this.baseView.query;
          this.$router
            .push({
              path: `/customer-receipt/review/${data.Code}`,
              query: {
                from: parentPage,
              },
            })
            .then(() => {
              this.reload = true;
              this.initialized();
            });
        })
        .catch((err) => {
          this.serverError = {
            err: err,
            msg: "Customer Receipt save failed",
            time: new Date().getTime(),
          };
          this.setLoading = false;
        });
    },

    createCustomerReceiptDetailPostProcess(data) {
      data.forEach((element) => {
        element.CheckInclude = true;

        if (element.FXDiscountReceived != undefined) {
          element.FXDiscount = element.FXDiscountReceived.roundNumber(2);
          element.Discount = element.DiscountReceived.roundNumber(2);

          if (
            element.CalculatedDueDate != null &&
            this.IsSettlementDateEnforced == "Yes" &&
            new Date(element.CalculatedDueDate).valueOf() <
              this.dataModel.DateIn
          ) {
            element.FXDiscount = 0;
            element.Discount = 0;
          }

          element.FXAllocationAmount = (
            element.FXBalance.roundNumber(2) - element.FXDiscount.roundNumber(2)
          ).roundNumber(2);

          element.FXAmount = element.FXAllocationAmount + element.FXDiscount;

          element.AllocationAmount = FxToBaseCurrency(
            element.FXAllocationAmount,
            element.ExchangeRate,
          );

          element.GainOrLoss = this.calculateGainOrLoss(
            element.FXAllocationAmount,
            element.FXDiscount,
            element.ExchangeRate,
            this.dataModel.ExchangeRate,
          );
        }
      });

      setTimeout(() => {
        this.updateHeaderCheckBox(data);
      }, 250);
      return data;
    },
  },
};
</script>

<style lang="scss">
.non-edit-cell-textbox-field-for-edit-bank-fee {
  flex-direction: row-reverse !important;
  text-align: end;
  label {
    padding-right: unset;
  }
}

.last-group {
  .dx-box-flex.dx-box.dx-widget.dx-collection {
    .dx-item-content.dx-box-item-content.dx-box-flex.dx-box.dx-widget.dx-collection {
      > div.dx-item.dx-box-item:nth-child(1) {
        div.dx-first-row.dx-first-col:not(.dx-field-item-required) {
          padding-right: 5px;
        }
      }
      > div.dx-item.dx-box-item:nth-child(2) {
        // display: unset !important;
        // min-width: unset !important;
        // flex: unset !important;
        // width: 20px !important;

        .fee-group {
          padding: 0;

          .edit-button {
            .dx-button-content {
              padding: 0 !important;
            }
            .dx-icon.dx-icon-edit::before {
              color: #03a9f4;
            }
          }

          .fee-group-emply-field {
            visibility: hidden;
            // .dx-texteditor.dx-editor-underlined::after {
            //   border-bottom: unset !important;
            // }
          }
        }
      }
      > div.dx-item.dx-box-item:nth-child(3) {
        > div > div {
          padding-left: 10px;
        }
      }
    }
  }
}

.last-group {
  .dx-form-group.dx-group-colcount-3 {
    .dx-box-flex.dx-box.dx-widget.dx-collection {
      .dx-item-content.dx-box-item-content.dx-box-flex.dx-box.dx-widget.dx-collection {
        > div.dx-item.dx-box-item:nth-child(2) {
          display: unset !important;
          min-width: unset !important;
          flex: unset !important;
          width: 20px !important;
        }
      }
    }
  }
}
</style>
